import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  CreateRecordingCommentDto,
  PublicRecordingComment,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createRecordingComment = async (
  orgId: string,
  recordingId: string,
  comment: CreateRecordingCommentDto,
): Promise<PublicRecordingComment> => {
  const response = await axiosClient.post(
    `/${orgId}/recordings/${recordingId}/comments`,
    comment,
  );
  return response.data;
};

function useCreateRecordingComment(
  recordingId: string,
  mutationOptions?: Partial<
    UseMutationOptions<
      PublicRecordingComment,
      HttpError,
      CreateRecordingCommentDto
    >
  >,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: (comment) =>
      createRecordingComment(organisation.id, recordingId, comment),
    ...mutationOptions,
  });
}

export { useCreateRecordingComment };
